import React from "react";

const AssetTypeCard = ({ name, count, icon }: any) => {
  const handleClick = () => {
    // Aquí puedes navegar a la vista filtrada por tipo
    console.log(`Navigating to ${name}`);
  };

  return (
    <div className="asset-type-card" onClick={handleClick}>
      <div className="asset-type-icon">{icon}</div>
      <div className="asset-type-info">
        <h4>{name}</h4>
        <div className="asset-type-count">{count}</div>
        <div className="asset-type-label">
          {count === 1 ? "Activo" : "Activos"}
        </div>
      </div>
    </div>
  );
};

export default AssetTypeCard;
